import React, {Component} from 'react';
import {observer} from "mobx-react";

class AttachmentSpoiler extends Component {
  render() {
    return (
      <div className="padd10 tac bg-w1-op50 fs14 center bg-w2-op50" style={{maxWidth: 400}}>
          В приложении к коментарию есть спойлеры.
          <div className="ptop10">
            <div className="btn2 small" onClick={()=>{
              this.props.data.show_spoiler=1;
            }}><span>Показать</span></div>
          </div>
      </div>
    )
  }
}

export default observer(AttachmentSpoiler);